(()=>{"use strict";var __webpack_modules__={"./src/js/find-in-store.js":(__unused_webpack_module,__webpack_exports__,__webpack_require__)=>{eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _utilities_calculate_geo_distance__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utilities/_calculate_geo_distance */ \"./src/js/utilities/_calculate_geo_distance.js\");\n\n(() => {\n  const Events = {\n    CHANGE: 'change',\n    CLICK: 'click',\n    INPUT: 'input'\n  };\n  const Classes = {\n    HIDDEN: 'hidden'\n  };\n  const Attributes = {\n    DISABLED: 'disabled'\n  };\n  let scrollY = 0;\n  let findInStoreSettingsElement = document.querySelector('#find-in-store');\n  const productInfoEl = findInStoreSettingsElement.closest('.product-info');\n  if (!findInStoreSettingsElement || !findInStoreSettingsElement?.innerText?.trim() || !productInfoEl) return;\n  const settings = JSON.parse(findInStoreSettingsElement.innerText);\n  if (!settings.product.available) return;\n  const drawerTriggerWrapper = getDrawerTriggerWrapper();\n  const drawer = getDrawer();\n  const productVariantInput = productInfoEl.querySelector('form input[name=id]');\n  if (!drawer || !productVariantInput) return;\n  initializeDrawerComponents();\n  window.FindInStore = {\n    open: openDrawer\n  };\n\n  // The \"Find in store\" button will be updated based on the value of product variant id input of the main product form.\n  updateDrawerTrigger();\n  productVariantInput?.addEventListener(Events.CHANGE, updateDrawerTrigger);\n  window.addEventListener('custom:cart-validated', updateDrawerTrigger);\n  async function updateDrawerTrigger() {\n    const config = window.Cart.getConfig();\n    const selectedVariantId = productVariantInput?.value;\n    let selectedVariantSku = settings.product.variants.find(variant => variant.id === Number(selectedVariantId))?.sku;\n    if (!selectedVariantSku && settings.product.variants.find(variant => variant.sku)) {\n      selectedVariantSku = settings.product.id;\n    }\n    if (selectedVariantSku) {\n      if (config.selected_location) {\n        const storeAvailabilityData = await window.Cart.getStoreAvailabilityData(selectedVariantSku);\n        const availabilityInSelectedLocation = storeAvailabilityData?.[config.selected_location.code];\n        const servicesAtSelectedLocation = availabilityInSelectedLocation?.service;\n        const oneHourccAvailable = window.settings.find_in_store.collect && window.settings.find_in_store['1hr_collect'] && availabilityInSelectedLocation?.qty > 0 && servicesAtSelectedLocation?.['1hcc'] === 1;\n        const ccAvailable = window.settings.find_in_store.collect && servicesAtSelectedLocation?.['cc'] === 1;\n        const reserveAvailable = window.settings.find_in_store.reserve && servicesAtSelectedLocation?.['reserve'] === 1;\n        if (oneHourccAvailable) {\n          renderDrawerTrigger(true, true);\n        } else if (ccAvailable || reserveAvailable) {\n          renderDrawerTrigger(true, false);\n        } else {\n          renderDrawerTrigger();\n        }\n      } else {\n        renderDrawerTrigger();\n      }\n    }\n  }\n  function renderDrawerTrigger(withSelectedStore, oneHourAvailable) {\n    let template = '';\n    if (!withSelectedStore) {\n      template = `\n\t\t\t\t<button class=\"find-in-store__button\" type=\"button\">\n\t\t\t\t\t${settings.buttonIcon}\n\t\t\t\t\t<span>${settings.buttonLabel}</span>\n\t\t\t\t</button>\n\t\t\t`;\n    } else {\n      template = `\n            <div class=\"find-in-store__availability-info\">\n                ${settings.availabilityInfoIcon}\n                <div class=\"find-in-store__availability-info__text-content\">\n                    ${withSelectedStoreName(!!oneHourAvailable ? settings.availableText : settings.unavailableText)}\n                    ${withSelectedStoreName(!!oneHourAvailable ? settings.availableText2 : settings.unavailableText2)}\n                    ${settings.checkStoresButtonLabel ? `<p><u>${settings.checkStoresButtonLabel}<u></p>` : null}\n                </div>\n            </div>\n        `;\n    }\n    drawerTriggerWrapper.innerHTML = template;\n  }\n\n  // Replaces [[selected_store]] in text with the name of the store currently selected for pickup\n  function withSelectedStoreName(text) {\n    const config = window.Cart.getConfig();\n    const trimmed = text?.trim();\n    if (trimmed) {\n      return `<p>${trimmed.replace('[[selected_store]]', config.selected_location?.name ? `<strong>${config.selected_location.name}</strong>` : '').trim()}</p>`;\n    }\n  }\n  function getDrawerTriggerWrapper() {\n    const wrapper = document.createElement('div');\n    wrapper.classList.add('find-in-store');\n    wrapper.style.display = 'none';\n    findInStoreSettingsElement.parentElement.replaceChild(wrapper, findInStoreSettingsElement);\n    wrapper.addEventListener(Events.CLICK, e => {\n      e.preventDefault();\n      e.stopPropagation();\n      openDrawer();\n    });\n    return wrapper;\n  }\n\n  // Returns drawer object containing the drawer and all of its components\n  function getDrawer() {\n    const drawerElement = document.querySelector('#find-in-store__drawer');\n    if (!drawerElement) return null;\n    document.body.appendChild(drawerElement);\n    drawerElement.setAttribute('data-initialized', true);\n    const drawer = {\n      self: drawerElement,\n      closeBtn: drawerElement.querySelector('.find-in-store__drawer__close-btn'),\n      productImage: drawerElement.querySelector('.find-in-store__drawer__product-info__image'),\n      selectedOptions: drawerElement.querySelector('.find-in-store__drawer__product-info__selected-options-list'),\n      selectedOptionsClearBtn: drawerElement.querySelector('.find-in-store__drawer__product-info__selected-options-list__clear-btn'),\n      variantPicker: drawerElement.querySelector('.find-in-store__drawer__variant-picker'),\n      selectedVariantIdInput: drawerElement.querySelector('.find-in-store__drawer__variant-picker input[name=id]'),\n      reservationFlow: drawerElement.querySelector('.find-in-store__drawer__reservation-flow'),\n      reservationForm: drawerElement.querySelector('.find-in-store__drawer__reservation-form'),\n      reservationInfo: drawerElement.querySelector('.find-in-store__drawer__reservation-info'),\n      storeSelector: drawerElement.querySelector('.find-in-store__drawer__store-selector'),\n      storeSearchInput: drawerElement.querySelector('.find-in-store__drawer__store-search-input'),\n      useCurrentLocationBtn: drawerElement.querySelector('.find-in-store__drawer__use-current-location-btn'),\n      storesWrapper: drawerElement.querySelector('.find-in-store__drawer__store-selector__stores-list'),\n      stores: []\n    };\n    return drawer;\n  }\n  function initializeDrawerComponents() {\n    drawer.selectedVariantIdInput.addEventListener(Events.CHANGE, renderStoresList);\n    drawer.selectedOptionsClearBtn.addEventListener(Events.CLICK, showVariantPicker);\n    drawer.closeBtn.addEventListener(Events.CLICK, closeDrawer);\n    drawer.self.addEventListener(Events.CLICK, e => {\n      if (e.target.contains(drawer.self)) closeDrawer();\n    });\n    initializeDrawerStoreSearch();\n    initializeSortByDistance();\n    initializeDrawerVariantPicker();\n    initializeReservationFlow();\n  }\n\n  // Initializes debounced search filtering on the store search input of the drawer\n  function initializeDrawerStoreSearch() {\n    if (!drawer.storeSearchInput) return;\n    let timeout = null;\n    drawer.storeSearchInput.addEventListener(Events.INPUT, () => {\n      const value = drawer.storeSearchInput.value.trim().toLocaleLowerCase();\n      if (timeout) clearTimeout(timeout);\n      timeout = setTimeout(() => {\n        drawer.stores.forEach(store => {\n          store.classList.toggle(Classes.HIDDEN, !!value && !(store.dataset.name?.toLocaleLowerCase().includes(value) || store.dataset.address?.toLocaleLowerCase().includes(value)));\n        });\n        timeout = null;\n      }, 200);\n    });\n  }\n  function initializeSortByDistance() {\n    if (!drawer.useCurrentLocationBtn) return;\n    drawer.useCurrentLocationBtn.addEventListener('click', () => {\n      navigator.geolocation.getCurrentPosition(position => {\n        const userLat = position.coords.latitude;\n        const userLng = position.coords.longitude;\n        const storesWithDistance = drawer.stores.map(store => ({\n          self: store,\n          distance: (0,_utilities_calculate_geo_distance__WEBPACK_IMPORTED_MODULE_0__.calculateGeoDistance)(userLat, userLng, Number(store.dataset.lat), Number(store.dataset.lng))\n        }));\n        drawer.storesWrapper.innerText = '';\n        storesWithDistance.sort((a, b) => a.distance - b.distance).forEach(store => {\n          drawer.storesWrapper.appendChild(store.self);\n        });\n      });\n    });\n  }\n  function initializeDrawerVariantPicker() {\n    const optionGroups = Array.from(drawer.variantPicker.querySelectorAll('.find-in-store__drawer__variant-picker__option')).map(group => ({\n      label: group.dataset.label,\n      options: Array.from(group.querySelectorAll('input[type=radio]'))\n    }));\n    toggleOptionsAvailability(optionGroups);\n    optionGroups.forEach(group => {\n      group.options.forEach(option => {\n        option.addEventListener(Events.CHANGE, () => {\n          toggleOptionsAvailability(optionGroups);\n          if (!option.checked) return;\n          const selectedOptions = optionGroups.map(_group => _group.options.find(_option => _option.checked)?.value).filter(Boolean);\n          if (selectedOptions.length === optionGroups.length) {\n            const selectedVariant = settings.product.variants.find(variant => variant.options.every((option, idx) => option === selectedOptions[idx]));\n            if (selectedVariant) {\n              drawer.selectedVariantIdInput.value = selectedVariant.id;\n              const featuredImage = selectedVariant.featured_image || settings.product.featured_image;\n              drawer.productImage.innerHTML = featuredImage ? `\n\t\t\t\t\t\t\t\t<img src=\"${featuredImage}\" width=\"80\" height=\"80\" alt=\"${settings.product.title} - ${selectedVariant.title}\">\n\t\t\t\t\t\t\t` : '';\n              drawer.selectedOptions.innerText = selectedOptions.map((option, idx) => `${optionGroups[idx].label}: ${option}`).join(', ');\n              renderStoresList(selectedVariant.sku);\n            }\n          }\n        });\n      });\n    });\n  }\n  function toggleOptionsAvailability(optionGroups) {\n    const selectionsByGroup = optionGroups.map(group => group.options.find(option => option.checked)?.value);\n    optionGroups.forEach((group, idx) => {\n      const previousSelections = selectionsByGroup.slice(0, idx);\n      group.options.forEach(option => {\n        const availableVariants = settings.product.variants.filter(variant => {\n          return variant.available && [...previousSelections, option.value].every((selection, _idx) => selection === undefined || selection === variant.options[_idx]);\n        });\n        option.classList.toggle('is-unavailable', !availableVariants.length);\n      });\n    });\n  }\n  function showVariantPicker() {\n    drawer.reservationFlow.classList.add(Classes.HIDDEN);\n    drawer.storeSelector.classList.add(Classes.HIDDEN);\n    drawer.variantPicker.classList.remove(Classes.HIDDEN);\n    drawer.selectedOptions.innerText = '';\n    drawer.variantPicker.querySelectorAll('.find-in-store__drawer__variant-picker__option.multi-option input[type=radio]').forEach(input => input.checked = false);\n  }\n  async function renderStoresList(sku) {\n    drawer.storesWrapper.innerText = '';\n    drawer.stores.length = 0;\n    drawer.storeSearchInput.value = '';\n    drawer.variantPicker.classList.add(Classes.HIDDEN);\n    drawer.reservationFlow.classList.add(Classes.HIDDEN);\n    drawer.storeSelector.classList.remove(Classes.HIDDEN);\n    let selectedVariantSku = sku;\n    if (!selectedVariantSku) {\n      const selectedVariant = settings.product.variants.find(variant => variant.id === Number(drawer.selectedVariantIdInput?.value));\n      if (!selectedVariant && settings.product.variants.find(variant => variant.sku)) return;\n      selectedVariantSku = selectedVariant?.sku || settings.product.id;\n    }\n    if (selectedVariantSku) {\n      const storeAvailabilityData = await window.Cart.getStoreAvailabilityData(selectedVariantSku);\n      if (!storeAvailabilityData) return;\n      for (let i = 0; i < window.stores.length; i++) {\n        const store = window.stores[i];\n        const data = storeAvailabilityData[store.code];\n        const storeCard = initializeStoreCard(store, data);\n        drawer.stores.push(storeCard);\n        drawer.storesWrapper.appendChild(storeCard);\n      }\n    }\n  }\n  function initializeStoreCard(store, availabilityData) {\n    const cartConfig = window.Cart.getConfig();\n    const availableForReserve = availabilityData?.service.reserve === 1 && store.reserve === true;\n    const availableForCC = availabilityData?.service.cc === 1 && store.cc === true;\n    const availableFor1hrCC = availabilityData?.service['1hcc'] === 1 && store['1hcc'] === true;\n    const reserveEnabled = !!window.settings.find_in_store.reserve;\n    const ccEnabled = !!window.settings.find_in_store.collect;\n    const oneHourCCEnabled = !!window.settings.find_in_store['1hr_collect'];\n    const storeCard = document.createElement('div');\n    storeCard.classList.add('find-in-store__drawer__store');\n    if (cartConfig.selected_location?.name === store.name) storeCard.classList.add('find-in-store__drawer__store--selected');\n    storeCard.setAttribute('data-name', store.name); // Is used by store search input to filter stores\n    storeCard.setAttribute('data-address', store.address); // Is used by store search input to filter stores\n    storeCard.setAttribute('data-lat', store.lat); // Is used to sort stores by distance from user's location\n    storeCard.setAttribute('data-lng', store.lng); // Is used to sort stores by distance from user's location\n    storeCard.innerHTML = `\n\t\t\t<p class=\"find-in-store__drawer__store__name\">${store.name}</p>\n\t\t\t${availabilityData?.qty > 0 ? `<p class=\"find-in-store__drawer__store__stock-info\">\n\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 5.52901L6.41426 12L3 8.64522L4.39172 7.11621L6.41426 9.10352L11.6083 4L13 5.52901Z\" fill=\"#129F10\"/></svg>\n\t\t\t\t\t\t${availabilityData?.qty} in stock\n\t\t\t\t\t</p>` : `<p class=\"find-in-store__drawer__store__lead-time-info\">\n\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" style=\"color: #F89D36;\" fill=\"none\"><g clip-path=\"url(#clip0_2248_507)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.5 2C0.223858 2 0 2.22386 0 2.5V10.5C0 10.7761 0.223858 11 0.5 11H15.5C15.7761 11 16 10.7761 16 10.5V7.5C16 7.36739 15.9473 7.24021 15.8536 7.14645L13.8536 5.14645C13.7598 5.05268 13.6326 5 13.5 5H11.5V2.5C11.5 2.22386 11.2761 2 11 2H0.5ZM11.5 6V10H15V7.70711L13.2929 6H11.5ZM10.5 3H1V10H10.5V3Z\" fill=\"currentColor\"/><path d=\"M2.50003 12C2.50003 12.5523 2.94775 13 3.50003 13C4.05232 13 4.50003 12.5523 4.50003 12H5.50003C5.50003 13.1046 4.6046 14 3.50003 14C2.39546 14 1.50003 13.1046 1.50003 12H2.50003Z\" fill=\"currentColor\"/><path d=\"M12.5 13C11.9477 13 11.5 12.5523 11.5 12H10.5C10.5 13.1046 11.3955 14 12.5 14C13.6046 14 14.5 13.1046 14.5 12H13.5C13.5 12.5523 13.0523 13 12.5 13Z\" fill=\"currentColor\"/></g><defs><clipPath id=\"clip0_2248_507\"><rect width=\"16\" height=\"16\" fill=\"white\"/></clipPath></defs></svg>\n\t\t\t\t\t\tCollect in Store in 2-3 days\n\t\t\t\t\t</p>`}\n\t\t\t<p class=\"find-in-store__drawer__store__address\">${store.address}</p>\n\t\t\t<a href=\"tel:${store.phone}\" class=\"find-in-store__drawer__store__phone\">${store.phone}</a>\n\t\t\t<p class=\"find-in-store__drawer__store__opening-hours\">${groupOpeningHours(store.opening_hours)}</p>\n\t\t\t<div class=\"find-in-store__drawer__store__atc-buttons\">\n\t\t\t\t${reserveEnabled ? `\n\t\t\t\t\t<button\n\t\t\t\t\t\tclass=\"find-in-store__drawer__store__atc-button btn button button--secondary\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\tdata-type=\"reserve\"\n\t\t\t\t\t\t${!availableForReserve ? 'disabled=\"true\"' : ''}\n\t\t\t\t\t>Reserve</button>\n\t\t\t\t\t` : ''}\n\t\t\t\t${ccEnabled ? `\n\t\t\t\t\t<button\n\t\t\t\t\t\tclass=\"find-in-store__drawer__store__atc-button btn button button--secondary\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\tdata-type=\"collect\"\n\t\t\t\t\t\t${!(availableForCC || oneHourCCEnabled && availableFor1hrCC) ? 'disabled=\"true\"' : ''}\n\t\t\t\t\t\t${oneHourCCEnabled && availableFor1hrCC ? 'data-onehourcc=\"true\"' : ''}\n\t\t\t\t\t>${oneHourCCEnabled && availableFor1hrCC ? '1hr ' : ''}Collect</button>\n\t\t\t\t\t` : ''}\n\t\t\t</div>\n\t\t`;\n    const atcButtons = storeCard.querySelectorAll('.find-in-store__drawer__store__atc-button');\n    atcButtons.forEach(button => {\n      if (!button.hasAttribute(Attributes.DISABLED)) {\n        button.addEventListener(Events.CLICK, () => {\n          if (button.dataset.type !== 'reserve') {\n            button.setAttribute(Attributes.DISABLED, true);\n          }\n\n          // Setting the pickup location to this store\n          window.Cart.setPickupLocation({\n            name: store.name,\n            code: store.code,\n            address: store.fullAddress\n          });\n\n          // Since the selected location is updated, we need to update the drawer trigger\n          updateDrawerTrigger();\n          if (button.dataset.type === 'reserve') {\n            showReservationForm();\n          } else {\n            const _1hr = !!button.dataset.onehourcc;\n            const selectedVariantId = drawer.selectedVariantIdInput.value;\n            const items = [{\n              id: selectedVariantId,\n              quantity: 1,\n              properties: {\n                _collection: true,\n                _1hr\n              }\n            }];\n            const handleAtc = async () => {\n              await window.Cart.add({\n                items\n              }, {\n                openCartDrawer: true\n              });\n              button.removeAttribute(Attributes.DISABLED);\n              closeDrawer();\n            };\n            const cartConfig = window.Cart.getConfig();\n            if (cartConfig.hd_only) {\n              closeDrawer();\n              window.showChoicePopup({\n                title: 'Please note: Only home delivery is available for some of the items currently in your cart.',\n                description: 'Choose wether you want to remove home delivery items or add this item for home delivery as well',\n                choices: [{\n                  label: 'Remove home delivery item(s)',\n                  onSelect: async () => {\n                    const hdOnlyItems = cartConfig.cart_items.filter(item => {\n                      const item_validation_data = cartConfig.validation_data?.skus?.[item.sku];\n                      return item_validation_data?.cc?.available === 0 || item.properties['_personalisation_id'] || item.properties['_assembly_id'] ? item : null;\n                    });\n                    const updates = {};\n                    hdOnlyItems.forEach(item => {\n                      updates[item.key] = 0;\n                    });\n                    await window.Cart.update({\n                      updates\n                    }, {\n                      validateCart: false\n                    });\n                    window.Cart.setDeliveryMethod('pickup');\n                    handleAtc();\n                  }\n                }, {\n                  label: 'Add this item for home delivery',\n                  onSelect: () => {\n                    delete items[0].properties;\n                    handleAtc();\n                  }\n                }],\n                onCancel: () => {\n                  button.removeAttribute(Attributes.DISABLED);\n                  closeDrawer();\n                }\n              });\n            } else {\n              window.Cart.setDeliveryMethod('pickup');\n              handleAtc();\n            }\n          }\n        });\n      }\n    });\n    return storeCard;\n  }\n  function groupOpeningHours(opening_hours) {\n    if (!opening_hours?.length) return '';\n    let openingHoursGroups = [];\n    let groupHours = '';\n    let daysGroup = [];\n    for (let i = 0; i < opening_hours.length; i++) {\n      const day = opening_hours[i]?.trim();\n      if (!day) continue;\n      const dayName = day.split(': ')[0];\n      const hours = day.split(': ')[1];\n      if (groupHours !== '' && hours !== groupHours) {\n        openingHoursGroups.push(`${daysGroup[0]}${daysGroup.length > 1 ? ` - ${daysGroup[daysGroup.length - 1]}` : ''} (${groupHours})`);\n        groupHours = hours;\n        daysGroup = [];\n      }\n      if (groupHours === '') groupHours = hours;\n      daysGroup.push(dayName);\n    }\n    openingHoursGroups.push(`${daysGroup[0]}${daysGroup.length > 1 ? ` - ${daysGroup[daysGroup.length - 1]}` : ''} (${groupHours})`);\n    return openingHoursGroups.join('; ');\n  }\n  function initializeReservationFlow() {\n    const endpoint = OrchestraV2?.product_reserve?.endpoint;\n    const hash = OrchestraV2?.product_reserve?.hash;\n    const date = OrchestraV2?.date;\n    if (!(drawer.reservationForm && endpoint && hash && date)) return;\n    const form = drawer.reservationForm;\n    const firstNameInput = form.querySelector('input[name=\"first_name\"]');\n    const lastNameInput = form.querySelector('input[name=\"last_name\"]');\n    const emailInput = form.querySelector('input[name=\"email\"]');\n    const phoneInput = form.querySelector('input[name=\"phone\"]');\n    const submitButton = form.querySelector('.find-in-store__drawer__reservation-form__submit-btn');\n    const reservationFlowFinishBtn = drawer.reservationFlow.querySelector('.find-in-store__drawer__reservation-flow__finish-btn');\n    const reservationFlowCancelBtn = drawer.reservationFlow.querySelector('.find-in-store__drawer__reservation-flow__cancel-btn');\n    submitButton.addEventListener('click', async e => {\n      e.preventDefault();\n      e.stopPropagation();\n      const inputValues = {\n        firstName: validateInput(firstNameInput),\n        lastName: validateInput(lastNameInput),\n        email: validateInput(emailInput),\n        phone: validateInput(phoneInput)\n      };\n      if (!(inputValues.firstName && inputValues.lastName && inputValues.email && inputValues.phone)) return;\n      const config = window.Cart.getConfig();\n      const selectedVariant = settings.product.variants.find(variant => variant.id === Number(drawer.selectedVariantIdInput?.value));\n      if (!(selectedVariant?.sku && config.selected_location?.name && config.selected_location?.code)) return;\n      submitButton.setAttribute(Attributes.DISABLED, true);\n      const payload = {\n        date,\n        security_hash: hash,\n        data: {\n          location: {\n            name: config.selected_location.name,\n            code: config.selected_location.code\n          },\n          sku: selectedVariant.sku,\n          variant_id: drawer.selectedVariantIdInput?.value,\n          quantity: 1,\n          name: inputValues.firstName,\n          surname: inputValues.lastName,\n          email: inputValues.email,\n          phone: inputValues.phone\n        }\n      };\n      const res = await fetch(endpoint, {\n        method: 'POST',\n        headers: {\n          'Content-Type': 'application/json'\n        },\n        body: JSON.stringify(payload)\n      });\n      const resData = await res.json();\n      submitButton.removeAttribute(Attributes.DISABLED);\n      if (resData.success && resData.data?.reference_id) {\n        const referenceIdWrapper = drawer.reservationInfo.querySelector('.find-in-store__drawer__reservation-info__reference-id');\n        const reservationInfoDetails = drawer.reservationInfo.querySelector('.find-in-store__drawer__reservation-info__details');\n        referenceIdWrapper.innerText = resData.data.reference_id;\n        const customerDetails = `${inputValues.firstName} | ${inputValues.email} | ${inputValues.phone}`;\n        const productDetails = `\n\t\t\t\t\t<p>\n\t\t\t\t\t\tQuantity: 1\n\t\t\t\t\t\t<br>\n\t\t\t\t\t\tTotal price: €${selectedVariant.price / 100}\n\t\t\t\t\t</p>\n\t\t\t\t`;\n        const store = window.stores.find(store => store.name === config.selected_location.name);\n        const storeDetails = store ? `\n\t\t\t\t\t<p><strong>Selected store</strong></p>\n                    <p>${store.name}</p>\n\t\t\t\t\t${store.phone || store.email ? `\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t${[store.phone ? `<a href=\"tel:${store.phone}\">${store.phone}</a>` : '', store.email ? `<a href=\"mailto:${store.email}\">${store.email}</a>` : ''].filter(Boolean).join('<br>')}\n\t\t\t\t\t\t</p>` : ''}\n\t\t\t\t\t${store.opening_hours ? `<p>${groupOpeningHours(store.opening_hours)}</p>` : ''}\n                    <a href=\"/pages/store-location\" class=\"find-in-store__drawer__reservation-info__view-map\">\n                        <svg width=\"21\" height=\"17\" viewBox=\"0 0 21 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t\t\t<path d=\"M19.9666 4.32435e-08C19.8517 -3.5531e-05 19.7384 0.0218782 19.6357 0.0640337L14.0319 2.36508L7.6953 0.0525076C7.68495 0.048879 7.67312 0.0482387 7.66202 0.0446101C7.63351 0.0358589 7.60435 0.0285661 7.57476 0.0227675C7.54534 0.0162575 7.51544 0.0111704 7.48529 0.00757735C7.42523 0.00352189 7.36487 0.00352189 7.30486 0.00757735C7.27471 0.0111704 7.24481 0.0162575 7.21539 0.0227675C7.1858 0.0285661 7.15663 0.0358589 7.12812 0.0446101C7.11703 0.0482387 7.1052 0.0488435 7.09485 0.0525076L0.439514 2.48105C0.172347 2.57846 0.00020082 2.79596 0.000244149 3.03594V16.3929C0.000374136 16.5983 0.126938 16.7897 0.336694 16.9017C0.546493 17.0138 0.811103 17.0312 1.03992 16.9478L7.39503 14.6286L13.7501 16.9478C13.7612 16.9514 13.7731 16.9478 13.7842 16.9533C13.9632 17.019 14.1687 17.0153 14.3439 16.943C14.3557 16.9387 14.3691 16.943 14.3809 16.9363L20.2967 14.5077C20.5474 14.4049 20.7058 14.1945 20.7057 13.9643V0.60743C20.7059 0.272107 20.375 0.00014234 19.9666 4.32435e-08ZM6.65558 13.5697L1.47919 15.4585V3.4306L6.65558 1.54179V13.5697ZM13.3109 15.4585L8.13453 13.5697V1.54179L13.3109 3.43057V15.4585ZM19.2268 13.5891L14.7899 15.4105V3.41114L19.2268 1.58974V13.5891Z\" fill=\"currentColor\"></path>\n\t\t\t\t\t\t</svg>\n                        <span class=\"link_text\">View map</span>\n                    </a>\n\t\t\t\t` : '';\n        const reservationDetails = `\n\t\t\t\t\t<strong>Details</strong>\n                    <p class=\"find-in-store__drawer__reservation-info__customer-details\">${customerDetails}</p>\n                    <div class=\"find-in-store__drawer__reservation-info__product-details\">${productDetails}</div>\n\t\t\t\t\t${storeDetails ? `<div class=\"find-in-store__drawer__reservation-info__store-details\">${storeDetails}</div>` : ''}\n\t\t\t\t`;\n        reservationInfoDetails.innerHTML = reservationDetails;\n        drawer.reservationInfo.classList.remove(Classes.HIDDEN);\n        drawer.reservationForm.classList.add(Classes.HIDDEN);\n      }\n    });\n    reservationFlowFinishBtn.addEventListener('click', closeDrawer);\n    reservationFlowCancelBtn.addEventListener('click', () => {\n      drawer.reservationFlow.classList.add(Classes.HIDDEN);\n      drawer.storeSelector.classList.remove(Classes.HIDDEN);\n    });\n  }\n  function validateInput(input) {\n    if (!input) return false;\n    const value = input.value.trim();\n    input.value = value;\n    if (!value) {\n      input.setAttribute('data-error', 'required');\n      return false;\n    }\n    if (input.type === 'text' && !/^[a-zA-Z0\\-\\'\\s]*$/.test(value) || input.type === 'email' && !/[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$/.test(value) || input.type === 'tel' && (!/^[\\+0-9][0-9\\s]*[0-9]$/.test(value) || !value.length >= 6)) {\n      input.setAttribute('data-error', 'invalid');\n      return false;\n    }\n    input.removeAttribute('data-error');\n    return value;\n  }\n  function showReservationForm() {\n    drawer.storeSelector.classList.add(Classes.HIDDEN);\n    drawer.variantPicker.classList.add(Classes.HIDDEN);\n    drawer.reservationInfo.classList.add(Classes.HIDDEN);\n    drawer.reservationForm.classList.remove(Classes.HIDDEN);\n    drawer.reservationFlow.classList.remove(Classes.HIDDEN);\n  }\n  function openDrawer() {\n    const hasMultipleVariants = settings.product.variants.length > 1;\n    if (hasMultipleVariants) {\n      showVariantPicker();\n    } else {\n      renderStoresList();\n    }\n    drawer.self.setAttribute('data-active', true);\n    scrollY = window.scrollY;\n    document.body.style.top = `-${scrollY}px`;\n    document.body.classList.add('fixed');\n  }\n  function closeDrawer() {\n    drawer.self.removeAttribute('data-active');\n    document.body.style.top = '';\n    document.body.classList.remove('fixed');\n    window.scrollTo(0, scrollY);\n  }\n})();\n\n//# sourceURL=webpack://project_workflow/./src/js/find-in-store.js?\n}")},"./src/js/utilities/_calculate_geo_distance.js":(__unused_webpack_module,__webpack_exports__,__webpack_require__)=>{eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   calculateGeoDistance: () => (/* binding */ calculateGeoDistance)\n/* harmony export */ });\nfunction calculateGeoDistance(lat1, lng1, lat2, lng2) {\n  const R = 6371; // Radius of the Earth in kilometers\n  const dLat = deg2rad(lat2 - lat1);\n  const dLng = deg2rad(lng2 - lng1);\n  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);\n  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));\n  const distance = R * c;\n  return distance;\n}\nfunction deg2rad(deg) {\n  return deg * (Math.PI / 180);\n}\n\n//# sourceURL=webpack://project_workflow/./src/js/utilities/_calculate_geo_distance.js?\n}")}},__webpack_module_cache__={};function __webpack_require__(e){var t=__webpack_module_cache__[e];if(void 0!==t)return t.exports;var n=__webpack_module_cache__[e]={exports:{}};return __webpack_modules__[e](n,n.exports,__webpack_require__),n.exports}__webpack_require__.d=(e,t)=>{for(var n in t)__webpack_require__.o(t,n)&&!__webpack_require__.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},__webpack_require__.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),__webpack_require__.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var __webpack_exports__=__webpack_require__("./src/js/find-in-store.js")})();


/* ============================================
   FIND IN STORE - ENHANCED STORE FINDER
   Intersport Elverys

   - Alphabetical stores by default
   - Stores Nearest Me toggle
   - Show Only Stores With Stock toggle
   - Matching blue outlined controls
   - Location and package icons
   - Works with selected product variant
   - Preserves Reserve and Collect
   ============================================ */

(function () {
  "use strict";

  const DRAWER = "#find-in-store__drawer";
  const LIST = ".find-in-store__drawer__store-selector__stores-list";
  const STORE = ".find-in-store__drawer__store";
  const BLUE = "#164196";

  let stockOnly = false;
  let nearestActive = false;
  let customerPosition = null;
  let locationPending = false;
  let listObserver = null;
  let filterScheduled = false;

  function getDrawer() {
    return document.querySelector(DRAWER);
  }

  function getStoreList() {
    return getDrawer()?.querySelector(LIST) || null;
  }

  function getStores() {
    const list = getStoreList();
    return list
      ? Array.from(list.querySelectorAll(STORE))
      : [];
  }

  /* ============================================
     STOCK AVAILABILITY
     ============================================ */

  function getStockQuantity(store) {
    const element = store.querySelector(
      ".find-in-store__drawer__store__stock-info"
    );

    if (!element) return 0;

    const match = element.textContent.match(/\d+/);

    return match ? Number(match[0]) : 0;
  }

  function filterStores() {
    getStores().forEach(function (store) {
      const hasStock = getStockQuantity(store) > 0;

      store.classList.toggle(
        "fis-stock-hidden",
        stockOnly && !hasStock
      );
    });
  }

  /* ============================================
     SORTING HELPERS
     ============================================ */

  function alphabeticalCompare(a, b) {
    return (a.dataset.name || "").localeCompare(
      b.dataset.name || "",
      undefined,
      { sensitivity: "base" }
    );
  }

  function reorderStores(stores) {
    const list = getStoreList();

    if (!list || !stores.length) return;

    const current = Array.from(list.children);

    const changed = stores.some(
      (store, index) => store !== current[index]
    );

    if (!changed) return;

    // Disconnect observer while moving cards.
    if (listObserver) {
      listObserver.disconnect();
    }

    const fragment = document.createDocumentFragment();

    stores.forEach(function (store) {
      fragment.appendChild(store);
    });

    list.appendChild(fragment);

    if (listObserver) {
      listObserver.observe(list, {
        childList: true
      });
    }
  }

  function sortAlphabetically() {
    const stores = getStores();
    stores.sort(alphabeticalCompare);
    reorderStores(stores);
  }

  /* ============================================
     DISTANCE CALCULATION
     ============================================ */

  function getDistance(store) {
    if (!customerPosition) return Infinity;

    const lat = Number(store.dataset.lat);
    const lng = Number(store.dataset.lng);

    if (
      !store.dataset.lat ||
      !store.dataset.lng ||
      !Number.isFinite(lat) ||
      !Number.isFinite(lng)
    ) {
      return Infinity;
    }

    const radians = Math.PI / 180;
    const radius = 6371;

    const dLat =
      (lat - customerPosition.latitude) * radians;

    const dLng =
      (lng - customerPosition.longitude) * radians;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(customerPosition.latitude * radians) *
      Math.cos(lat * radians) *
      Math.sin(dLng / 2) ** 2;

    return (
      2 * radius *
      Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    );
  }

  function sortNearest() {
    if (!customerPosition) return;

    const stores = getStores();

    stores.sort(function (a, b) {
      const difference =
        getDistance(a) - getDistance(b);

      return difference || alphabeticalCompare(a, b);
    });

    reorderStores(stores);
  }

  function applyStorePreferences() {
    if (nearestActive && customerPosition) {
      sortNearest();
    } else {
      sortAlphabetically();
    }

    filterStores();
  }

  /* ============================================
     SEARCH PLACEHOLDER
     ============================================ */

  function updateSearchPlaceholder() {
    const input = getDrawer()?.querySelector(
      ".find-in-store__drawer__store-search-input"
    );

    if (input) {
      input.placeholder = "Search for a Store";
    }
  }

  /* ============================================
     SVG ICONS
     ============================================ */

  const packageIcon = `
    <svg
      class="fis-control-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/>
      <path d="m3.3 7 8.7 5 8.7-5"/>
      <path d="M12 22V12"/>
      <path d="m7.5 4.5 9 5"/>
    </svg>
  `;

  /* ============================================
     SHARED TOGGLE MARKUP
     ============================================ */

  function switchMarkup() {
    return `
      <span
        class="fis-toggle-switch"
        aria-hidden="true"
      ></span>
    `;
  }

  /* ============================================
     STORES NEAREST ME BUTTON
     ============================================ */

  function getLocationButton() {
    return getDrawer()?.querySelector(
      ".find-in-store__drawer__use-current-location-btn"
    );
  }

  function updateLocationButton() {
    const button = getLocationButton();

    if (!button) return;

    const text = button.querySelector(
      ".fis-location-text"
    );

    if (text) {
      text.textContent = "Stores Nearest Me";
    }

    button.setAttribute(
      "aria-pressed",
      String(nearestActive)
    );

    button.setAttribute(
      "aria-label",
      "Stores Nearest Me"
    );

    button.classList.toggle(
      "fis-control-active",
      nearestActive
    );
  }

  function prepareLocationButton() {
    const button = getLocationButton();

    if (!button) return;

    if (button.dataset.fisEnhanced === "true") {
      return;
    }

    button.dataset.fisEnhanced = "true";
    button.classList.add("fis-control");

    // Preserve the existing location icon.
    const originalIcon = button.querySelector("svg");

    const iconMarkup = originalIcon
      ? originalIcon.outerHTML
      : "";

    button.innerHTML = `
      <span class="fis-control-content">
        ${iconMarkup}

        <span class="fis-location-text">
          Stores Nearest Me
        </span>
      </span>

      ${switchMarkup()}
    `;

    updateLocationButton();

    // Capture the click so the original
    // one-way geolocation handler doesn't run.
    button.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (locationPending) return;

        // Toggle OFF - alphabetical order.
        if (nearestActive) {
          nearestActive = false;

          updateLocationButton();
          applyStorePreferences();
          return;
        }

        // Reuse location if already granted.
        if (customerPosition) {
          nearestActive = true;

          updateLocationButton();
          applyStorePreferences();
          return;
        }

        if (!navigator.geolocation) {
          alert(
            "Location is not supported by this browser."
          );
          return;
        }

        locationPending = true;

        button.setAttribute("aria-busy", "true");

        navigator.geolocation.getCurrentPosition(
          function (position) {
            locationPending = false;

            button.removeAttribute("aria-busy");

            customerPosition = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            };

            nearestActive = true;

            updateLocationButton();
            applyStorePreferences();
          },

          function () {
            locationPending = false;

            button.removeAttribute("aria-busy");

            nearestActive = false;
            updateLocationButton();

            alert(
              "Please enable location access to find your nearest stores."
            );
          },

          {
            enableHighAccuracy: false,
            timeout: 12000,
            maximumAge: 300000
          }
        );
      },
      true
    );
  }

  /* ============================================
     STOCK FILTER TOGGLE
     ============================================ */

  function addStockToggle() {
    const drawer = getDrawer();
    const locationButton = getLocationButton();

    if (!drawer || !locationButton) return;

    if (
      drawer.querySelector(
        "#find-in-store-stock-toggle"
      )
    ) {
      return;
    }

    const wrapper = document.createElement("div");

    wrapper.className =
      "find-in-store__stock-filter";

    wrapper.innerHTML = `
      <label
        class="fis-control fis-stock-control"
        for="find-in-store-stock-toggle"
      >
        <span class="fis-control-content">
          ${packageIcon}

          <span class="fis-stock-text">
            Show Only Stores With Stock
          </span>
        </span>

        <input
          type="checkbox"
          id="find-in-store-stock-toggle"
          class="fis-stock-input"
        >

        ${switchMarkup()}
      </label>
    `;

    locationButton.insertAdjacentElement(
      "afterend",
      wrapper
    );

    const toggle = wrapper.querySelector(
      "#find-in-store-stock-toggle"
    );

    const label = wrapper.querySelector(
      ".fis-stock-control"
    );

    toggle.checked = stockOnly;

    function updateStockState() {
      stockOnly = toggle.checked;

      label.classList.toggle(
        "fis-control-active",
        stockOnly
      );

      filterStores();
    }

    toggle.addEventListener(
      "change",
      updateStockState
    );

    updateStockState();
  }

  /* ============================================
     CSS STYLING
     ============================================ */

  function addStyles() {
    const styleId = "fis-matching-toggle-styles";

    if (document.getElementById(styleId)) {
      return;
    }

    const style = document.createElement("style");

    style.id = styleId;

    style.textContent = `

      /* SHARED CONTROL DESIGN */

      ${DRAWER} .fis-control {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;

        width: calc(100% - 32px);
        min-height: 48px;

        margin: 10px 16px 0;
        padding: 12px 14px;

        background: #ffffff;
        border: 1px solid ${BLUE};
        border-radius: 6px;

        box-sizing: border-box;
        cursor: pointer;

        color: ${BLUE};
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        text-align: left;
        text-transform: none;

        transition:
          background-color 0.2s ease,
          border-color 0.2s ease;
      }

      ${DRAWER} .fis-control:hover {
        background-color: #f0f4fb;
      }

      ${DRAWER} .fis-control-active {
        background-color: #eef3fc;
      }

      /* CONTENT & ICONS */

      ${DRAWER} .fis-control-content {
        display: flex;
        align-items: center;
        gap: 10px;

        flex: 1;
        min-width: 0;
      }

      ${DRAWER} .fis-control-content > svg,
      ${DRAWER} .fis-control-icon {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;

        color: ${BLUE};
        flex-shrink: 0;
      }

      ${DRAWER} .fis-control-icon {
        fill: none;
        stroke: currentColor;
      }

      ${DRAWER} .fis-location-text,
      ${DRAWER} .fis-stock-text {
        color: ${BLUE};
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        text-transform: none;
      }

      /* LOCATION CONTROL */

      ${DRAWER}
      .find-in-store__drawer__use-current-location-btn.fis-control {
        display: flex;
        width: calc(100% - 32px);
        margin: 10px 16px 0;
        padding: 12px 14px;
        border: 1px solid ${BLUE};
        border-radius: 6px;
        background-color: #ffffff;
        box-sizing: border-box;
      }

      ${DRAWER}
      .find-in-store__drawer__use-current-location-btn.fis-control[aria-pressed="true"] {
        background-color: #eef3fc;
      }

      ${DRAWER}
      .find-in-store__drawer__use-current-location-btn.fis-control:hover {
        background-color: #f0f4fb;
      }

      /* STOCK CONTROL */

      ${DRAWER} .find-in-store__stock-filter {
        margin: 0;
        padding: 0;
      }

      ${DRAWER} .fis-stock-control {
        width: calc(100% - 32px);
        margin: 10px 16px 0;
      }

      /* SHARED SWITCH */

      ${DRAWER} .fis-toggle-switch {
        position: relative;
        display: inline-block;

        width: 44px;
        height: 24px;

        background: #c2c2c2;
        border-radius: 24px;

        flex-shrink: 0;

        transition: background-color 0.2s ease;
      }

      ${DRAWER} .fis-toggle-switch::before {
        content: "";

        position: absolute;
        top: 3px;
        left: 3px;

        width: 18px;
        height: 18px;

        background: #ffffff;
        border-radius: 50%;

        transition: transform 0.2s ease;
      }

      /* LOCATION SWITCH ACTIVE */

      ${DRAWER}
      .find-in-store__drawer__use-current-location-btn[aria-pressed="true"]
      .fis-toggle-switch {
        background-color: ${BLUE};
      }

      ${DRAWER}
      .find-in-store__drawer__use-current-location-btn[aria-pressed="true"]
      .fis-toggle-switch::before {
        transform: translateX(20px);
      }

      /* HIDDEN STOCK CHECKBOX */

      ${DRAWER} .fis-stock-input {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }

      /* STOCK SWITCH ACTIVE */

      ${DRAWER}
      .fis-stock-input:checked
      + .fis-toggle-switch {
        background-color: ${BLUE};
      }

      ${DRAWER}
      .fis-stock-input:checked
      + .fis-toggle-switch::before {
        transform: translateX(20px);
      }

      /* FOCUS STATES */

      ${DRAWER}
      .fis-control:focus-visible,
      ${DRAWER}
      .fis-stock-input:focus-visible
      + .fis-toggle-switch {
        outline: 2px solid ${BLUE};
        outline-offset: 3px;
      }

      /* LOCATION LOADING */

      ${DRAWER}
      .fis-control[aria-busy="true"] {
        opacity: 0.65;
        cursor: wait;
      }

      /* HIDE STORES WITH NO STOCK */

      ${DRAWER} .fis-stock-hidden {
        display: none !important;
      }

      /* STORE LIST SPACING */

      ${DRAWER}
      .find-in-store__drawer__store-selector__stores-list {
        margin-top: 0 !important;
      }

      ${DRAWER}
      .find-in-store__drawer__store-selector__stores-list
      > .find-in-store__drawer__store:first-child {
        padding-top: 10px;
      }

      /* MOBILE */

      @media (max-width: 400px) {
        ${DRAWER} .fis-control {
          padding: 11px 12px;
          gap: 8px;
        }

        ${DRAWER} .fis-location-text,
        ${DRAWER} .fis-stock-text {
          font-size: 13px;
        }

        ${DRAWER} .fis-control-content {
          gap: 8px;
        }

        ${DRAWER}
        .find-in-store__drawer__use-current-location-btn.fis-control {
          padding: 11px 12px;
        }
      }

    `;

    document.head.appendChild(style);
  }

  /* ============================================
     WATCH FOR VARIANT / STORE UPDATES
     ============================================ */

  function observeStores() {
    const list = getStoreList();

    if (!list) return;

    listObserver = new MutationObserver(function () {
      if (filterScheduled) return;

      filterScheduled = true;

      requestAnimationFrame(function () {
        filterScheduled = false;

        applyStorePreferences();
      });
    });

    listObserver.observe(list, {
      childList: true
    });

    applyStorePreferences();
  }

  /* ============================================
     INITIALIZE
     ============================================ */

  function initialize() {
    const drawer = getDrawer();

    if (!drawer) return;

    updateSearchPlaceholder();

    addStyles();

    prepareLocationButton();
    addStockToggle();

    observeStores();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }

})();